function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#818085",
  d: "M166.957 270.831h178.087v22.261H166.957z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M196.638 204.052L256 211.474l59.362-7.422v-35.617l-23.745 11.872L256 144.69l-35.617 35.617-23.745-11.872z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M181.797 315.357h-22.261v-40.811l7.421-11.131-7.421-11.13v-25.971h22.261zm170.667 0h-22.261v-89.043h22.261v25.97l-7.421 11.317 7.421 10.947z",
  fill: "#f0f0f0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#acabb1",
  d: "M159.533 252.288h192.924v22.261H159.533z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M256 345.038c-32.732 0-59.362-26.63-59.362-59.362v-81.623h118.725v81.623c-.001 32.732-26.631 59.362-59.363 59.362z",
  fill: "#f0f0f0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256 322.777c-20.458 0-37.101-16.643-37.101-37.101v-59.362h74.203v59.362c-.001 20.458-16.644 37.101-37.102 37.101z",
  fill: "#0052b4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M196.641 204.049h22.261v22.261h-22.261zm96.457 0h22.261v22.261h-22.261zm0 48.239h22.261v22.261h-22.261zm-96.457 0h22.261v22.261h-22.261zm48.229-48.239h22.261v22.261H244.87zM256 322.777c-3.877 0-7.615-.6-11.13-1.709v22.908c3.608.688 7.325 1.062 11.13 1.062s7.522-.374 11.13-1.062v-22.908a36.928 36.928 0 01-11.13 1.709zm-36.605-31.078l-17.766 17.766a59.577 59.577 0 0012.876 18.606l15.733-15.733c-5.614-5.426-9.525-12.6-10.843-20.639zm90.976 17.766l-17.766-17.766c-1.319 8.038-5.229 15.212-10.843 20.638l15.733 15.733a59.578 59.578 0 0012.876-18.605z",
  fill: "#d80027"
});

const SvgMelilla = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMelilla, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/melilla.8a2a3d60.svg";
export { ForwardRef as ReactComponent };